<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '@/lib/utils';
import { platforms, type PlatformKey } from './platforms';

const props = withDefaults(
    defineProps<{ platform: PlatformKey; class?: string }>(),
    { class: '' },
);

const meta = computed(() => platforms[props.platform]);
</script>

<template>
    <span
        :class="
            cn(
                'border-border bg-card inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm',
                props.class,
            )
        "
    >
        <component
            :is="meta.icon"
            class="text-muted-foreground size-4"
            aria-hidden="true"
        />
        {{ meta.label }}
    </span>
</template>
